<head>
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
</head>

<div style="margin-bottom: 0px;font-family: 'Segoe UI', 'Segoe', 'SegoeUI-Regular-final', Tahoma, Helvetica, Arial, sans-serif;">
    <div style="text-align: center; background: bisque;border-width: 0 0 1px;padding: 15px;">
        <p>This MICROSOFT INTERNAL ONLY website is targeted to the Office Dogfood <a href="https://nam06.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmicrosoft.sharepoint-df.com%2Fteams%2Fdogfood%2FPages%2FSPE-InnerRingFAQ.aspx&data=04%7C01%7CDi.Sun%40microsoft.com%7C306593f9591a47bbfe8e08d758d4d8c8%7C72f988bf86f141af91ab2d7cd011db47%7C1%7C0%7C637075543501507600%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C-1&sdata=e2lpb%2BVGkqAT4%2FBcGp2OKGTusVM%2BS5buOkRzFkXDTXw%3D&reserved=0">
            M65 Inner Ring members</a>.</p>
        <p>Feedback to <a href=mailto:orangealert@microsoft.com>Orange Alerts</a>.</p> 
    </div> 
    <div style="width: 100%;height: 50px;display: flex;background-color: lightblue;">
        <div style = "flex: 1 0 auto;text-align: center;font-size: 200%">
            Incident
        </div>
        <div style = "display: flex;">
            <span [class.hidden]="!isLoggedIn||!msal.isUserAuthenticated">Hello, {{msal.currentUserName}}!</span>
            <span [class.hidden]="!isLoggedIn||!msal.isUserAuthenticated" style="margin-left: 20px;"><a href="javascript:;" style="text-shadow:none" (click)="msal.logout()" class="app-logout">Logout</a></span>
        </div>
    </div>
    
</div>

<main>
    <div *ngIf="!isLoggedIn" style="text-align: center">
        <h4>Welcome to incident portal, please click the button to <button  *ngIf="!isLoggedIn" (click)="loginRedirect()" style="color:#fff;background-color: #337ab7">Login</button> </h4> 
    </div>
  <div *ngIf="isUserAuthorized==true">
      <router-outlet></router-outlet>
  </div>

  <div class="spinner" [hidden]="!objSpinnerStatus"></div>
  
  <div *ngIf="isUserAuthorized==false" [innerHTML]="statusMessage"></div> 

  <div [ngClass]="{'tokenexpireDiv': isTokenExpired}">
      <div *ngIf="isTokenExpired==true">
          <p class="tokenexpiremsg">Your session has expired, please <button (click)="refresh()">Refresh</button> the page to continue.</p>
      </div>
  </div>
</main>